<ng-container
  *ngLet="{
    searching: searching | async,
    selected: selected | async,
    placeholder: placeholder | async,
    value: value | async,
    chipValue: chipValue | async,
    autoFocus: autoFocus | async,
    loading: loading | async,
    search: search | async
  } as vm"
>
  <deprecated-text-field
    *ngIf="vm.searching"
    class="bare"
    rv-autocomplete
    [placeholder]="vm.loading ? 'loading' : vm.placeholder"
    [search]="vm.search"
    [ngModel]="vm.chipValue"
    [disabled]="vm.loading"
    [autoFocus]="vm.autoFocus"
    (selected)="selected.next($event)"
  ></deprecated-text-field>
  <chip
    class="chip"
    *ngIf="!vm.searching"
    (remove)="clear.next()"
    [text]="vm.chipValue"
  ></chip>
</ng-container>
